import { createRouter, createWebHistory } from "vue-router";
import store from "../store";
import LayoutPublic from "../layouts/Public.vue";
import LayoutUser from "../layouts/User.vue";

import {
  routes as userRoutes,
  middleware as userMiddleware,
} from "@/views/user/Routes";

const routes = [
  {
    path: "/verify",
    name: "Verify",
    component: () => import("../views/public/Verify"),
    //redirect: (to) => {
    //return '/user/';
    //},
  },
  {
    path: "/",
    name: "",
    component: LayoutPublic,
    children: [
      {
        path: "",
        name: "PublicHome",
        component: () => import("../views/public/Home"),
        //redirect: (to) => {
        //return '/user/';
        //},
      },

      {
        path: "/contact-us",
        name: "PublicContactUs",
        component: () => import("../views/public/Contactus"),
        //redirect: (to) => {
        //return '/user/';
        //},
      },

      {
        path: "/faq",
        name: "PublicFaq",
        component: () => import("../views/public/Faq"),
        //redirect: (to) => {
        //return '/user/';
        //},
      },
      {
        path: "/terms",
        name: "PublicTerms",
        component: () => import("../views/public/Terms"),
        //redirect: (to) => {
        //return '/user/';
        //},
      },

      {
        path: "/about-us",
        name: "PublicAboutUs",
        component: () => import("../views/public/Aboutus"),
        //redirect: (to) => {
        //return '/user/';
        //},
      },

      {
        path: "/blogs",
        name: "PublicBlogs",
        component: () => import("../views/public/Blog"),
        //redirect: (to) => {
        //return '/user/';
        //},
      },
      {
        path: "/blogs/:id",
        name: "PublicBlogArticle",
        component: () => import("../views/public/BlogArticle"),
      },

      {
        path: "/store",
        name: "PublicStore",
        component: () => import("../views/public/Store"),
        //redirect: (to) => {
        //return '/user/';
        //},
      },
      {
        path: "/store/:id",
        name: "PublicStoreSingel",
        component: () => import("../views/public/SingelStore"),
        //redirect: (to) => {
        //return '/user/';
        //},
      },
      {
        path: "/p/:slug",
        name: "PublicCmsPage",
        component: () => import("../views/public/CmsPage"),
      },
    ],
  },

  ...userRoutes,
  {
    path: '/wallet/payment-callback',
    name: 'WalletPaymentCallback',
    component: () => import('@/views/user/WalletPaymentCallback.vue')
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

function buildKycRedirectQuery(to) {
  const redirectQuery = { reason: 'kyc' };

  if (to?.name === 'PanelUser-Exchange') {
    redirectQuery.redirect = 'exchange';

    if (to.query?.tab) {
      redirectQuery.tab = String(to.query.tab);
    }
    if (to.query?.purchaseType) {
      redirectQuery.purchaseType = String(to.query.purchaseType);
    }
    if (to.query?.amount) {
      redirectQuery.amount = String(to.query.amount);
    }
    if (to.query?.rial) {
      redirectQuery.rial = String(to.query.rial);
    }
    if (to.query?.gold) {
      redirectQuery.gold = String(to.query.gold);
    }

    return redirectQuery;
  }

  if (typeof to?.fullPath === 'string' && to.fullPath) {
    redirectQuery.redirect = to.fullPath;
  }

  return redirectQuery;
}

router.beforeEach((to, from, next) => {
  if (
    to.matched.some((record) => {
      /**
       * خیلی مهم:
       * میدلور هر لایه حساب کاربری باید به طوری جداگانه فراخوانی شود
       * و در زیر قرار بگیرد
       *
       **/
      // console.log(record);

      userMiddleware(record, next, store.state.userIsAuthenticated);
    })
    /* eslint-disable */
  ) {
  } else {
    next(); // make sure to always call next()!
  }
});

// Global KYC and feature gating
router.beforeEach((to, from, next) => {
  try {
    const protectedRouteNames = [
      'PanelUser-Exchange',
      'PanelUser-Withdraws',
      'PanelUser-Card',
      'PanelUser-Wallet'
    ];
    const disabledFeatureNames = [
      // Temporarily disable Gold-to-Gold feature
      'PanelUser-Gldtogld'
    ];

    // Derive KYC status from store first, then fall back to cached user data after refresh.
    let cachedUser = {};
    try {
      cachedUser = JSON.parse(localStorage.getItem('hz_user_cache') || '{}');
    } catch (_) {}

    const user = store.state.userDetails?.kycStatus || store.state.userDetails?.kyc_verified
      ? store.state.userDetails
      : (store.state.user && Object.keys(store.state.user).length ? store.state.user : cachedUser);
    const kycStatus = user.kycStatus || (user.kyc && user.kyc.status) || user.kyc_verified;
    const isKycVerified = kycStatus === 'verified' || kycStatus === true;

    if (disabledFeatureNames.includes(to.name)) {
      // Redirect to home with coming soon flag
      return next({ name: 'PublicHome', query: { comingSoon: '1' } });
    }

    if (protectedRouteNames.includes(to.name)) {
      if (!isKycVerified) {
        // Redirect to KYC page with a serializable target so the flow can resume safely.
        return next({ name: 'PanelUser-Kyc', query: buildKycRedirectQuery(to) });
      }
    }
  } catch (e) {
    // Fail-open to avoid blocking navigation unexpectedly
  }
  return next();
});

export default router;
